import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Simplifying bureaucracy for everyone',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      dashboard: 'Dashboard',
      bills: 'My Bills',
      appointments: 'Appointments',
      history: 'Payment History',
      settings: 'Settings',
      teoudat_zehout: 'Teoudat Zehout',
      code: 'Personal Code',
      full_name: 'Full Name',
      language: 'Language',
      welcome: 'Welcome',
      total_debt: 'Total Outstanding',
      unpaid_bills: 'Unpaid Bills',
      upcoming_due: 'Due Soon',
      pay_now: 'Pay Now',
      pay: 'Pay',
      paid: 'Paid',
      unpaid: 'Unpaid',
      overdue: 'Overdue',
      due_date: 'Due Date',
      amount: 'Amount',
      category: 'Category',
      provider: 'Provider',
      description: 'Description',
      status: 'Status',
      water: 'Water',
      electricity: 'Electricity',
      arnona: 'Property Tax',
      fines: 'Fines',
      education: 'Education',
      health: 'Health',
      general: 'General',
      book_appointment: 'Book an Appointment',
      office_type: 'Office Type',
      office_name: 'Office Name',
      select_date: 'Select Date',
      select_time: 'Select Time',
      confirm_booking: 'Confirm Booking',
      post_office: 'Post Office',
      misrad_hapanim: 'Ministry of Interior',
      misrad_harishoui: 'Licensing Authority (Driving License)',
      misrad_darkonim: 'Passport Office',
      maaser_hnassa: 'Tax Authority',
      bituah_leumi: 'National Insurance',
      municipality: 'Municipality',
      payment_date: 'Payment Date',
      payment_method: 'Payment Method',
      view_details: 'View Details',
      all: 'All',
      recent_payments: 'Recent Payments',
      my_appointments: 'My Appointments',
      no_bills: 'No bills found',
      no_appointments: 'No appointments scheduled',
      no_payments: 'No payment history',
      save_changes: 'Save Changes',
      cancel: 'Cancel',
      payment_success: 'Payment successful!',
      appointment_success: 'Appointment booked successfully!',
      login_prompt: 'Please login to access the system',
      register_prompt: 'Create a new account',
      already_have_account: 'Already have an account?',
      dont_have_account: "Don't have an account?",
      create_account: 'Create Account',
      enter_details: 'Enter your details',
      filter_by_status: 'Filter by status',
      filter_by_category: 'Filter by category',
      notifications: 'Notifications',
      no_notifications: 'No notifications',
      bill_reminder: 'Bill Reminder',
      mark_as_read: 'Mark as read',
      new_notification: 'New notification',
      partial_payment: 'Partial Payment',
      full_payment: 'Full Payment',
      payment_amount: 'Payment Amount',
      remaining_balance: 'Remaining Balance',
      generate_shovar: 'Generate Shovar (PDF)',
      shovar_number: 'Shovar Number',
      cash_payment: 'Cash Payment',
      my_children: 'My Children',
      add_child: 'Add Child',
      child_name: 'Child Name',
      child_teoudat: 'Child Teoudat Zehout',
      birth_date: 'Birth Date',
      school_name: 'School Name',
      vaad_bayit: 'Building Committee',
      chat_with_assistant: 'Chat with Assistant',
      ask_question: 'Ask a question...',
      how_can_help: 'How can I help you today?',
      change_address: 'Change Address',
      my_address: 'My Address',
      current_address: 'Current Address',
      new_address: 'New Address',
      address_line_1: 'Street Address',
      city: 'City',
      postal_code: 'Postal Code',
      update_address: 'Update Address',
      address_updated: 'Address updated successfully!',
      address_history: 'Address History',
      organizations_updated: 'Organizations Updated',
      changed_on: 'Changed on',
      propagated_to: 'Automatically propagated to all organizations',
      install_app: 'Install SHALEM App',
      install_app_subtitle: 'Quick access from your home screen',
      install_now: 'Install Now',
      ios_install_instructions: 'To install on iPhone:',
      tap_share: 'Tap Share',
      add_to_home: 'Add to Home Screen',
      secure_payment: 'Secure Payment',
      amount_to_pay: 'Amount to Pay',
      payment_method: 'Payment Method',
      card_number: 'Card Number',
      cardholder_name: 'Cardholder Name',
      expiry_date: 'Expiry Date',
      loading: 'Loading...',
      saving: 'Saving...',
      days_left: 'days left',
      day_left: 'day left',
      no_urgent_bills: 'No urgent bills!',
      all_caught_up: 'All caught up!',
      no_unpaid_bills: 'You have no unpaid bills at the moment.',
      profile_info: 'Profile Information',
      manage_preferences: 'Manage your preferences',
      no_children_yet: 'No children added yet',
      login_success: 'Login successful!',
      register_success: 'Account created successfully!',
      select_all: 'Select all',
      deselect_all: 'Deselect all',
      selected: 'selected'
    }
  },
  he: {
    translation: {
      app_name: 'שלם',
      tagline: 'מפשטים ביורוקרטיה לכולם',
      login: 'התחברות',
      register: 'הרשמה',
      logout: 'התנתקות',
      dashboard: 'לוח בקרה',
      bills: 'החשבונות שלי',
      appointments: 'תורים',
      history: 'היסטוריית תשלומים',
      settings: 'הגדרות',
      teoudat_zehout: 'תעודת זהות',
      code: 'קוד אישי',
      full_name: 'שם מלא',
      language: 'שפה',
      welcome: 'ברוך הבא',
      total_debt: 'סך החוב',
      unpaid_bills: 'חשבונות ממתינים',
      upcoming_due: 'קרובים למועד',
      pay_now: 'שלם עכשיו',
      pay: 'שלם',
      paid: 'שולם',
      unpaid: 'לא שולם',
      overdue: 'באיחור',
      due_date: 'תאריך פירעון',
      amount: 'סכום',
      category: 'קטגוריה',
      provider: 'ספק',
      description: 'תיאור',
      status: 'סטטוס',
      water: 'מים',
      electricity: 'חשמל',
      arnona: 'ארנונה',
      fines: 'קנסות',
      education: 'חינוך',
      health: 'בריאות',
      general: 'כללי',
      book_appointment: 'קביעת תור',
      office_type: 'סוג משרד',
      office_name: 'שם המשרד',
      select_date: 'בחר תאריך',
      select_time: 'בחר שעה',
      confirm_booking: 'אישור התור',
      post_office: 'דואר ישראל',
      misrad_hapanim: 'משרד הפנים',
      misrad_harishoui: 'משרד הרישוי (רישיון נהיגה)',
      misrad_darkonim: 'משרד הדרכונים',
      maaser_hnassa: 'מס הכנסה',
      bituah_leumi: 'ביטוח לאומי',
      municipality: 'עיריה',
      payment_date: 'תאריך תשלום',
      payment_method: 'אמצעי תשלום',
      view_details: 'צפה בפרטים',
      all: 'הכל',
      recent_payments: 'תשלומים אחרונים',
      my_appointments: 'התורים שלי',
      no_bills: 'לא נמצאו חשבונות',
      no_appointments: 'אין תורים מתוזמנים',
      no_payments: 'אין היסטוריית תשלומים',
      save_changes: 'שמור שינויים',
      cancel: 'ביטול',
      payment_success: 'התשלום בוצע בהצלחה!',
      appointment_success: 'התור נקבע בהצלחה!',
      login_prompt: 'אנא התחבר כדי לגשת למערכת',
      register_prompt: 'צור חשבון חדש',
      already_have_account: 'כבר יש לך חשבון?',
      dont_have_account: 'אין לך חשבון?',
      create_account: 'צור חשבון',
      enter_details: 'הזן את הפרטים שלך',
      filter_by_status: 'סינון לפי סטטוס',
      filter_by_category: 'סינון לפי קטגוריה',
      notifications: 'התראות',
      no_notifications: 'אין התראות',
      bill_reminder: 'תזכורת חשבון',
      mark_as_read: 'סמן כנקרא',
      new_notification: 'התראה חדשה',
      partial_payment: 'תשלום חלקי',
      full_payment: 'תשלום מלא',
      payment_amount: 'סכום לתשלום',
      remaining_balance: 'יתרה נותרת',
      generate_shovar: 'הפקת שובר (PDF)',
      shovar_number: 'מספר שובר',
      cash_payment: 'תשלום במזומן',
      my_children: 'הילדים שלי',
      add_child: 'הוסף ילד',
      child_name: 'שם הילד',
      child_teoudat: 'תעודת זהות ילד',
      birth_date: 'תאריך לידה',
      school_name: 'שם בית הספר',
      vaad_bayit: 'ועד בית',
      chat_with_assistant: 'שיחה עם עוזר',
      ask_question: 'שאל שאלה...',
      how_can_help: 'איך אני יכול לעזור לך היום?',
      change_address: 'שינוי כתובת',
      my_address: 'הכתובת שלי',
      current_address: 'כתובת נוכחית',
      new_address: 'כתובת חדשה',
      address_line_1: 'כתובת רחוב',
      city: 'עיר',
      postal_code: 'מיקוד',
      update_address: 'עדכון כתובת',
      address_updated: 'הכתובת עודכנה בהצלחה!',
      address_history: 'היסטוריית כתובות',
      organizations_updated: 'ארגונים עודכנו',
      changed_on: 'שונה בתאריך',
      propagated_to: 'הופץ אוטומטית לכל הארגונים',
      install_app: 'התקן את אפליקציית שלם',
      install_app_subtitle: 'גישה מהירה ממסך הבית',
      install_now: 'התקן עכשיו',
      ios_install_instructions: 'להתקנה באייפון:',
      tap_share: 'לחץ על שיתוף',
      add_to_home: 'הוסף למסך הבית',
      secure_payment: 'תשלום מאובטח',
      amount_to_pay: 'סכום לתשלום',
      card_number: 'מספר כרטיס',
      cardholder_name: 'שם בעל הכרטיס',
      expiry_date: 'תאריך תפוגה',
      loading: '...טוען',
      saving: '...שומר',
      days_left: 'ימים נותרו',
      day_left: 'יום נותר',
      no_urgent_bills: 'אין חשבונות דחופים!',
      all_caught_up: 'הכל מעודכן!',
      no_unpaid_bills: 'אין לך חשבונות ממתינים כרגע.',
      profile_info: 'פרטי פרופיל',
      manage_preferences: 'נהל את ההעדפות שלך',
      no_children_yet: 'לא נוספו ילדים עדיין',
      login_success: 'התחברת בהצלחה!',
      register_success: 'החשבון נוצר בהצלחה!',
      select_all: 'בחר הכל',
      deselect_all: 'בטל הכל',
      selected: 'נבחרו'
    }
  },
  fr: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Simplifier la bureaucratie pour tous',
      login: 'Connexion',
      register: 'Inscription',
      logout: 'Déconnexion',
      dashboard: 'Tableau de bord',
      bills: 'Mes factures',
      appointments: 'Rendez-vous',
      history: 'Historique des paiements',
      settings: 'Paramètres',
      teoudat_zehout: 'Teoudat Zehout',
      code: 'Code personnel',
      full_name: 'Nom complet',
      language: 'Langue',
      welcome: 'Bienvenue',
      total_debt: 'Total impayé',
      unpaid_bills: 'Factures impayées',
      upcoming_due: 'Échéances proches',
      pay_now: 'Payer maintenant',
      pay: 'Payer',
      paid: 'Payé',
      unpaid: 'Impayé',
      overdue: 'En retard',
      due_date: 'Date d\'échéance',
      amount: 'Montant',
      category: 'Catégorie',
      provider: 'Fournisseur',
      description: 'Description',
      status: 'Statut',
      water: 'Eau',
      electricity: 'Électricité',
      arnona: 'Arnona',
      fines: 'Amendes',
      education: 'Éducation',
      health: 'Santé',
      general: 'Général',
      book_appointment: 'Prendre rendez-vous',
      office_type: 'Type de bureau',
      office_name: 'Nom du bureau',
      select_date: 'Sélectionner une date',
      select_time: 'Sélectionner une heure',
      confirm_booking: 'Confirmer le rendez-vous',
      post_office: 'Bureau de poste',
      misrad_hapanim: 'Ministère de l\'Intérieur',
      misrad_harishoui: 'Bureau des permis (Permis de conduire)',
      misrad_darkonim: 'Bureau des passeports',
      maaser_hnassa: 'Autorité fiscale',
      bituah_leumi: 'Assurance nationale',
      municipality: 'Municipalité',
      payment_date: 'Date de paiement',
      payment_method: 'Méthode de paiement',
      view_details: 'Voir les détails',
      all: 'Tous',
      recent_payments: 'Paiements récents',
      my_appointments: 'Mes rendez-vous',
      no_bills: 'Aucune facture trouvée',
      no_appointments: 'Aucun rendez-vous planifié',
      no_payments: 'Aucun historique de paiement',
      save_changes: 'Enregistrer les modifications',
      cancel: 'Annuler',
      payment_success: 'Paiement réussi!',
      appointment_success: 'Rendez-vous réservé avec succès!',
      login_prompt: 'Veuillez vous connecter pour accéder au système',
      register_prompt: 'Créer un nouveau compte',
      already_have_account: 'Vous avez déjà un compte?',
      dont_have_account: 'Vous n\'avez pas de compte?',
      create_account: 'Créer un compte',
      enter_details: 'Entrez vos informations',
      filter_by_status: 'Filtrer par statut',
      filter_by_category: 'Filtrer par catégorie',
      notifications: 'Notifications',
      no_notifications: 'Aucune notification',
      bill_reminder: 'Rappel de facture',
      mark_as_read: 'Marquer comme lu',
      new_notification: 'Nouvelle notification',
      partial_payment: 'Paiement partiel',
      full_payment: 'Paiement total',
      payment_amount: 'Montant à payer',
      remaining_balance: 'Solde restant',
      generate_shovar: 'Générer Shovar (PDF)',
      shovar_number: 'Numéro de Shovar',
      cash_payment: 'Paiement en espèces',
      my_children: 'Mes enfants',
      add_child: 'Ajouter un enfant',
      child_name: 'Nom de l\'enfant',
      child_teoudat: 'Teoudat Zehout enfant',
      birth_date: 'Date de naissance',
      school_name: 'Nom de l\'école',
      vaad_bayit: 'Comité d\'immeuble',
      chat_with_assistant: 'Discuter avec l\'assistant',
      ask_question: 'Posez une question...',
      how_can_help: 'Comment puis-je vous aider aujourd\'hui ?',
      change_address: 'Changer d\'adresse',
      my_address: 'Mon adresse',
      current_address: 'Adresse actuelle',
      new_address: 'Nouvelle adresse',
      address_line_1: 'Adresse',
      city: 'Ville',
      postal_code: 'Code postal',
      update_address: 'Mettre à jour l\'adresse',
      address_updated: 'Adresse mise à jour avec succès !',
      address_history: 'Historique des adresses',
      organizations_updated: 'Organismes mis à jour',
      changed_on: 'Modifié le',
      propagated_to: 'Propagé automatiquement à tous les organismes',
      install_app: 'Installer l\'application SHALEM',
      install_app_subtitle: 'Accès rapide depuis votre écran d\'accueil',
      install_now: 'Installer maintenant',
      ios_install_instructions: 'Pour installer sur iPhone :',
      tap_share: 'Appuyez sur Partager',
      add_to_home: 'Ajouter à l\'écran d\'accueil',
      secure_payment: 'Paiement sécurisé',
      amount_to_pay: 'Montant à payer',
      card_number: 'Numéro de carte',
      cardholder_name: 'Nom du titulaire',
      expiry_date: 'Date d\'expiration',
      loading: 'Chargement...',
      saving: 'Sauvegarde...',
      days_left: 'jours restants',
      day_left: 'jour restant',
      no_urgent_bills: 'Aucune facture urgente !',
      all_caught_up: 'Tout est à jour !',
      no_unpaid_bills: 'Vous n\'avez aucune facture impayée pour le moment.',
      profile_info: 'Informations du profil',
      manage_preferences: 'Gérer vos préférences',
      no_children_yet: 'Aucun enfant ajouté pour le moment',
      login_success: 'Connexion réussie !',
      register_success: 'Compte créé avec succès !',
      select_all: 'Tout sélectionner',
      deselect_all: 'Tout désélectionner',
      selected: 'sélectionnés'
    }
  },
  es: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Simplificando la burocracia para todos',
      login: 'Iniciar sesión',
      register: 'Registrarse',
      logout: 'Cerrar sesión',
      dashboard: 'Panel',
      bills: 'Mis facturas',
      appointments: 'Citas',
      history: 'Historial de pagos',
      settings: 'Configuración',
      teoudat_zehout: 'Teoudat Zehout',
      code: 'Código personal',
      full_name: 'Nombre completo',
      language: 'Idioma',
      welcome: 'Bienvenido',
      total_debt: 'Total pendiente',
      unpaid_bills: 'Facturas sin pagar',
      upcoming_due: 'Próximos vencimientos',
      pay_now: 'Pagar ahora',
      pay: 'Pagar',
      paid: 'Pagado',
      unpaid: 'Sin pagar',
      overdue: 'Vencido',
      due_date: 'Fecha de vencimiento',
      amount: 'Cantidad',
      category: 'Categoría',
      provider: 'Proveedor',
      description: 'Descripción',
      status: 'Estado',
      water: 'Agua',
      electricity: 'Electricidad',
      arnona: 'Impuesto municipal',
      fines: 'Multas',
      education: 'Educación',
      health: 'Salud',
      general: 'General',
      book_appointment: 'Reservar cita',
      office_type: 'Tipo de oficina',
      office_name: 'Nombre de la oficina',
      select_date: 'Seleccionar fecha',
      select_time: 'Seleccionar hora',
      confirm_booking: 'Confirmar reserva',
      post_office: 'Oficina de correos',
      misrad_hapanim: 'Ministerio del Interior',
      bituah_leumi: 'Seguro Nacional',
      municipality: 'Municipalidad',
      payment_date: 'Fecha de pago',
      payment_method: 'Método de pago',
      view_details: 'Ver detalles',
      all: 'Todos',
      recent_payments: 'Pagos recientes',
      my_appointments: 'Mis citas',
      no_bills: 'No se encontraron facturas',
      no_appointments: 'No hay citas programadas',
      no_payments: 'Sin historial de pagos',
      save_changes: 'Guardar cambios',
      cancel: 'Cancelar',
      payment_success: '¡Pago exitoso!',
      appointment_success: '¡Cita reservada exitosamente!',
      login_prompt: 'Por favor inicie sesión para acceder al sistema',
      register_prompt: 'Crear una nueva cuenta',
      already_have_account: '¿Ya tienes una cuenta?',
      dont_have_account: '¿No tienes una cuenta?',
      create_account: 'Crear cuenta',
      enter_details: 'Ingresa tus datos',
      filter_by_status: 'Filtrar por estado',
      filter_by_category: 'Filtrar por categoría',
      notifications: 'Notificaciones',
      no_notifications: 'Sin notificaciones',
      bill_reminder: 'Recordatorio de factura',
      mark_as_read: 'Marcar como leído',
      new_notification: 'Nueva notificación',
      partial_payment: 'Pago parcial',
      full_payment: 'Pago total',
      payment_amount: 'Monto a pagar',
      remaining_balance: 'Saldo restante',
      generate_shovar: 'Generar Shovar (PDF)',
      shovar_number: 'Número de Shovar',
      cash_payment: 'Pago en efectivo',
      my_children: 'Mis hijos',
      add_child: 'Agregar hijo',
      child_name: 'Nombre del hijo',
      child_teoudat: 'Teoudat Zehout del hijo',
      birth_date: 'Fecha de nacimiento',
      school_name: 'Nombre de la escuela',
      vaad_bayit: 'Comité de edificio',
      chat_with_assistant: 'Chatear con asistente',
      ask_question: 'Haz una pregunta...',
      how_can_help: '¿Cómo puedo ayudarte hoy?',
      change_address: 'Cambiar dirección',
      my_address: 'Mi dirección',
      current_address: 'Dirección actual',
      new_address: 'Nueva dirección',
      address_line_1: 'Dirección',
      city: 'Ciudad',
      postal_code: 'Código postal',
      update_address: 'Actualizar dirección',
      address_updated: '¡Dirección actualizada con éxito!',
      address_history: 'Historial de direcciones',
      organizations_updated: 'Organismos actualizados',
      changed_on: 'Cambiado el',
      propagated_to: 'Propagado automáticamente a todos los organismos',
      install_app: 'Instalar la aplicación SHALEM',
      install_app_subtitle: 'Acceso rápido desde tu pantalla',
      install_now: 'Instalar ahora',
      secure_payment: 'Pago seguro',
      amount_to_pay: 'Monto a pagar',
      card_number: 'Número de tarjeta',
      cardholder_name: 'Nombre del titular',
      expiry_date: 'Fecha de expiración',
      loading: 'Cargando...',
      saving: 'Guardando...',
      days_left: 'días restantes',
      day_left: 'día restante',
      no_urgent_bills: '¡No hay facturas urgentes!',
      all_caught_up: '¡Todo al día!',
      no_unpaid_bills: 'No tienes facturas pendientes por el momento.',
      profile_info: 'Información del perfil',
      manage_preferences: 'Gestiona tus preferencias',
      no_children_yet: 'Aún no se han agregado hijos',
      login_success: '¡Inicio de sesión exitoso!',
      register_success: '¡Cuenta creada con éxito!',
      select_all: 'Seleccionar todo',
      deselect_all: 'Deseleccionar todo',
      selected: 'seleccionados'
    }
  },
  ru: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Упрощаем бюрократию для всех',
      login: 'Войти',
      register: 'Регистрация',
      logout: 'Выйти',
      dashboard: 'Панель',
      bills: 'Мои счета',
      appointments: 'Записи',
      history: 'История платежей',
      settings: 'Настройки',
      teoudat_zehout: 'Теудат Зеут',
      code: 'Личный код',
      full_name: 'Полное имя',
      language: 'Язык',
      welcome: 'Добро пожаловать',
      total_debt: 'Общая задолженность',
      unpaid_bills: 'Неоплаченные счета',
      upcoming_due: 'Срочные к оплате',
      pay_now: 'Оплатить сейчас',
      pay: 'Оплатить',
      paid: 'Оплачено',
      unpaid: 'Не оплачено',
      overdue: 'Просрочено',
      due_date: 'Срок оплаты',
      amount: 'Сумма',
      category: 'Категория',
      provider: 'Поставщик',
      description: 'Описание',
      status: 'Статус',
      water: 'Вода',
      electricity: 'Электричество',
      arnona: 'Арнона',
      fines: 'Штрафы',
      education: 'Образование',
      health: 'Здоровье',
      general: 'Общее',
      book_appointment: 'Записаться',
      office_type: 'Тип офиса',
      office_name: 'Название офиса',
      select_date: 'Выберите дату',
      select_time: 'Выберите время',
      confirm_booking: 'Подтвердить запись',
      post_office: 'Почта',
      misrad_hapanim: 'МВД',
      bituah_leumi: 'Битуах Леуми',
      municipality: 'Муниципалитет',
      payment_date: 'Дата платежа',
      payment_method: 'Способ оплаты',
      view_details: 'Подробности',
      all: 'Все',
      recent_payments: 'Последние платежи',
      my_appointments: 'Мои записи',
      no_bills: 'Счета не найдены',
      no_appointments: 'Нет запланированных записей',
      no_payments: 'Нет истории платежей',
      save_changes: 'Сохранить изменения',
      cancel: 'Отмена',
      payment_success: 'Платеж успешен!',
      appointment_success: 'Запись успешно создана!',
      login_prompt: 'Пожалуйста, войдите для доступа к системе',
      register_prompt: 'Создать новую учетную запись',
      already_have_account: 'Уже есть учетная запись?',
      dont_have_account: 'Нет учетной записи?',
      create_account: 'Создать учетную запись',
      enter_details: 'Введите свои данные',
      filter_by_status: 'Фильтр по статусу',
      filter_by_category: 'Фильтр по категории',
      notifications: 'Уведомления',
      no_notifications: 'Нет уведомлений',
      bill_reminder: 'Напоминание о счёте',
      mark_as_read: 'Отметить как прочитанное',
      new_notification: 'Новое уведомление',
      partial_payment: 'Частичная оплата',
      full_payment: 'Полная оплата',
      payment_amount: 'Сумма платежа',
      remaining_balance: 'Остаток',
      generate_shovar: 'Создать шовар (PDF)',
      shovar_number: 'Номер шовара',
      cash_payment: 'Наличный платёж',
      my_children: 'Мои дети',
      add_child: 'Добавить ребёнка',
      child_name: 'Имя ребёнка',
      child_teoudat: 'Теудат Зеут ребёнка',
      birth_date: 'Дата рождения',
      school_name: 'Название школы',
      vaad_bayit: 'Домовой комитет',
      chat_with_assistant: 'Чат с ассистентом',
      ask_question: 'Задайте вопрос...',
      how_can_help: 'Чем я могу помочь вам сегодня?',
      change_address: 'Сменить адрес',
      my_address: 'Мой адрес',
      current_address: 'Текущий адрес',
      new_address: 'Новый адрес',
      address_line_1: 'Адрес',
      city: 'Город',
      postal_code: 'Почтовый индекс',
      update_address: 'Обновить адрес',
      address_updated: 'Адрес успешно обновлён!',
      address_history: 'История адресов',
      organizations_updated: 'Организации обновлены',
      changed_on: 'Изменено',
      propagated_to: 'Автоматически передано во все организации',
      install_app: 'Установить приложение SHALEM',
      install_app_subtitle: 'Быстрый доступ с главного экрана',
      install_now: 'Установить сейчас',
      secure_payment: 'Безопасная оплата',
      amount_to_pay: 'Сумма к оплате',
      card_number: 'Номер карты',
      cardholder_name: 'Имя владельца карты',
      expiry_date: 'Срок действия',
      loading: 'Загрузка...',
      saving: 'Сохранение...',
      days_left: 'дней осталось',
      day_left: 'день остался',
      no_urgent_bills: 'Нет срочных счетов!',
      all_caught_up: 'Все актуально!',
      no_unpaid_bills: 'У вас нет неоплаченных счетов.',
      profile_info: 'Информация профиля',
      manage_preferences: 'Управление настройками',
      no_children_yet: 'Дети ещё не добавлены',
      login_success: 'Вход выполнен!',
      register_success: 'Аккаунт создан!',
      select_all: 'Выбрать всё',
      deselect_all: 'Отменить всё',
      selected: 'выбрано'
    }
  },
  ar: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'تبسيط البيروقراطية للجميع',
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      logout: 'تسجيل الخروج',
      dashboard: 'لوحة التحكم',
      bills: 'فواتيري',
      appointments: 'المواعيد',
      history: 'سجل المدفوعات',
      settings: 'الإعدادات',
      teoudat_zehout: 'تعودات زيهوت',
      code: 'الرمز الشخصي',
      full_name: 'الاسم الكامل',
      language: 'اللغة',
      welcome: 'مرحباً',
      total_debt: 'إجمالي المستحق',
      unpaid_bills: 'الفواتير غير المدفوعة',
      upcoming_due: 'قريبة الاستحقاق',
      pay_now: 'ادفع الآن',
      pay: 'ادفع',
      paid: 'مدفوع',
      unpaid: 'غير مدفوع',
      overdue: 'متأخر',
      due_date: 'تاريخ الاستحقاق',
      amount: 'المبلغ',
      category: 'الفئة',
      provider: 'المزود',
      description: 'الوصف',
      status: 'الحالة',
      water: 'ماء',
      electricity: 'كهرباء',
      arnona: 'ضريبة الأملاك',
      fines: 'الغرامات',
      education: 'التعليم',
      health: 'الصحة',
      general: 'عام',
      book_appointment: 'حجز موعد',
      office_type: 'نوع المكتب',
      office_name: 'اسم المكتب',
      select_date: 'اختر التاريخ',
      select_time: 'اختر الوقت',
      confirm_booking: 'تأكيد الحجز',
      post_office: 'مكتب البريد',
      misrad_hapanim: 'وزارة الداخلية',
      bituah_leumi: 'التأمين الوطني',
      municipality: 'البلدية',
      payment_date: 'تاريخ الدفع',
      payment_method: 'طريقة الدفع',
      view_details: 'عرض التفاصيل',
      all: 'الكل',
      recent_payments: 'المدفوعات الأخيرة',
      my_appointments: 'مواعيدي',
      no_bills: 'لم يتم العثور على فواتير',
      no_appointments: 'لا توجد مواعيد مجدولة',
      no_payments: 'لا يوجد سجل للمدفوعات',
      save_changes: 'حفظ التغييرات',
      cancel: 'إلغاء',
      payment_success: 'تم الدفع بنجاح!',
      appointment_success: 'تم حجز الموعد بنجاح!',
      login_prompt: 'الرجاء تسجيل الدخول للوصول إلى النظام',
      register_prompt: 'إنشاء حساب جديد',
      already_have_account: 'هل لديك حساب بالفعل؟',
      dont_have_account: 'ليس لديك حساب؟',
      create_account: 'إنشاء حساب',
      enter_details: 'أدخل تفاصيلك',
      filter_by_status: 'تصفية حسب الحالة',
      filter_by_category: 'تصفية حسب الفئة',
      notifications: 'الإشعارات',
      no_notifications: 'لا توجد إشعارات',
      bill_reminder: 'تذكير بالفاتورة',
      mark_as_read: 'وضع علامة كمقروء',
      new_notification: 'إشعار جديد',
      partial_payment: 'دفع جزئي',
      full_payment: 'دفع كامل',
      payment_amount: 'المبلغ المطلوب',
      remaining_balance: 'الرصيد المتبقي',
      generate_shovar: 'إنشاء شوفار (PDF)',
      shovar_number: 'رقم الشوفار',
      cash_payment: 'دفع نقدي',
      my_children: 'أطفالي',
      add_child: 'إضافة طفل',
      child_name: 'اسم الطفل',
      child_teoudat: 'تعودات زهوت الطفل',
      birth_date: 'تاريخ الميلاد',
      school_name: 'اسم المدرسة',
      vaad_bayit: 'لجنة المبنى',
      chat_with_assistant: 'الدردشة مع المساعد',
      ask_question: 'اطرح سؤالاً...',
      how_can_help: 'كيف يمكنني مساعدتك اليوم؟',
      change_address: 'تغيير العنوان',
      my_address: 'عنواني',
      current_address: 'العنوان الحالي',
      new_address: 'العنوان الجديد',
      address_line_1: 'عنوان الشارع',
      city: 'المدينة',
      postal_code: 'الرمز البريدي',
      update_address: 'تحديث العنوان',
      address_updated: 'تم تحديث العنوان بنجاح!',
      address_history: 'سجل العناوين',
      organizations_updated: 'المؤسسات المحدثة',
      changed_on: 'تم التغيير في',
      propagated_to: 'تم النشر تلقائياً لجميع المؤسسات',
      install_app: 'تثبيت تطبيق SHALEM',
      install_app_subtitle: 'وصول سريع من شاشتك الرئيسية',
      install_now: 'تثبيت الآن',
      secure_payment: 'دفع آمن',
      amount_to_pay: 'المبلغ المطلوب',
      card_number: 'رقم البطاقة',
      cardholder_name: 'اسم حامل البطاقة',
      expiry_date: 'تاريخ الانتهاء',
      loading: '...جاري التحميل',
      saving: '...جاري الحفظ',
      days_left: 'أيام متبقية',
      day_left: 'يوم متبقي',
      no_urgent_bills: 'لا توجد فواتير عاجلة!',
      all_caught_up: 'كل شيء محدث!',
      no_unpaid_bills: 'ليس لديك فواتير غير مدفوعة حالياً.',
      profile_info: 'معلومات الملف الشخصي',
      manage_preferences: 'إدارة التفضيلات',
      no_children_yet: 'لم يتم إضافة أطفال بعد',
      login_success: 'تم تسجيل الدخول بنجاح!',
      register_success: 'تم إنشاء الحساب بنجاح!',
      select_all: 'تحديد الكل',
      deselect_all: 'إلغاء تحديد الكل',
      selected: 'محدد'
    }
  },
  it: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Semplificare la burocrazia per tutti',
      login: 'Accedi',
      register: 'Registrati',
      logout: 'Esci',
      dashboard: 'Dashboard',
      bills: 'Le mie fatture',
      appointments: 'Appuntamenti',
      history: 'Cronologia pagamenti',
      settings: 'Impostazioni',
      teoudat_zehout: 'Teoudat Zehout',
      code: 'Codice personale',
      full_name: 'Nome completo',
      language: 'Lingua',
      welcome: 'Benvenuto',
      total_debt: 'Totale in sospeso',
      unpaid_bills: 'Fatture non pagate',
      upcoming_due: 'In scadenza',
      pay_now: 'Paga ora',
      pay: 'Paga',
      paid: 'Pagato',
      unpaid: 'Non pagato',
      overdue: 'Scaduto',
      due_date: 'Data di scadenza',
      amount: 'Importo',
      category: 'Categoria',
      provider: 'Fornitore',
      description: 'Descrizione',
      status: 'Stato',
      water: 'Acqua',
      electricity: 'Elettricità',
      arnona: 'Tassa comunale',
      fines: 'Multe',
      education: 'Istruzione',
      health: 'Salute',
      general: 'Generale',
      book_appointment: 'Prenota appuntamento',
      office_type: 'Tipo di ufficio',
      office_name: 'Nome dell\'ufficio',
      select_date: 'Seleziona data',
      select_time: 'Seleziona ora',
      confirm_booking: 'Conferma prenotazione',
      post_office: 'Ufficio postale',
      misrad_hapanim: 'Ministero dell\'Interno',
      bituah_leumi: 'Assicurazione nazionale',
      municipality: 'Municipio',
      payment_date: 'Data di pagamento',
      payment_method: 'Metodo di pagamento',
      view_details: 'Visualizza dettagli',
      all: 'Tutti',
      recent_payments: 'Pagamenti recenti',
      my_appointments: 'I miei appuntamenti',
      no_bills: 'Nessuna fattura trovata',
      no_appointments: 'Nessun appuntamento programmato',
      no_payments: 'Nessuna cronologia pagamenti',
      save_changes: 'Salva modifiche',
      cancel: 'Annulla',
      payment_success: 'Pagamento riuscito!',
      appointment_success: 'Appuntamento prenotato con successo!',
      login_prompt: 'Effettua il login per accedere al sistema',
      register_prompt: 'Crea un nuovo account',
      already_have_account: 'Hai già un account?',
      dont_have_account: 'Non hai un account?',
      create_account: 'Crea account',
      enter_details: 'Inserisci i tuoi dati',
      filter_by_status: 'Filtra per stato',
      filter_by_category: 'Filtra per categoria',
      notifications: 'Notifiche',
      no_notifications: 'Nessuna notifica',
      bill_reminder: 'Promemoria fattura',
      mark_as_read: 'Segna come letto',
      new_notification: 'Nuova notifica',
      partial_payment: 'Pagamento parziale',
      full_payment: 'Pagamento totale',
      payment_amount: 'Importo da pagare',
      remaining_balance: 'Saldo rimanente',
      generate_shovar: 'Genera Shovar (PDF)',
      shovar_number: 'Numero Shovar',
      cash_payment: 'Pagamento in contanti',
      my_children: 'I miei figli',
      add_child: 'Aggiungi figlio',
      child_name: 'Nome del figlio',
      child_teoudat: 'Teoudat Zehout figlio',
      birth_date: 'Data di nascita',
      school_name: 'Nome della scuola',
      vaad_bayit: 'Comitato edificio',
      chat_with_assistant: 'Chatta con l\'assistente',
      ask_question: 'Fai una domanda...',
      how_can_help: 'Come posso aiutarti oggi?',
      change_address: 'Cambia indirizzo',
      my_address: 'Il mio indirizzo',
      current_address: 'Indirizzo attuale',
      new_address: 'Nuovo indirizzo',
      address_line_1: 'Indirizzo',
      city: 'Città',
      postal_code: 'Codice postale',
      update_address: 'Aggiorna indirizzo',
      address_updated: 'Indirizzo aggiornato con successo!',
      address_history: 'Cronologia indirizzi',
      organizations_updated: 'Enti aggiornati',
      changed_on: 'Modificato il',
      propagated_to: 'Propagato automaticamente a tutti gli enti',
      install_app: 'Installa l\'app SHALEM',
      install_app_subtitle: 'Accesso rapido dalla schermata',
      install_now: 'Installa ora',
      secure_payment: 'Pagamento sicuro',
      amount_to_pay: 'Importo da pagare',
      card_number: 'Numero carta',
      cardholder_name: 'Nome titolare',
      expiry_date: 'Data di scadenza',
      loading: 'Caricamento...',
      saving: 'Salvataggio...',
      days_left: 'giorni rimanenti',
      day_left: 'giorno rimanente',
      no_urgent_bills: 'Nessuna fattura urgente!',
      all_caught_up: 'Tutto aggiornato!',
      no_unpaid_bills: 'Non hai fatture non pagate al momento.',
      profile_info: 'Informazioni del profilo',
      manage_preferences: 'Gestisci le tue preferenze',
      no_children_yet: 'Nessun figlio aggiunto ancora',
      login_success: 'Accesso effettuato!',
      register_success: 'Account creato con successo!',
      select_all: 'Seleziona tutto',
      deselect_all: 'Deseleziona tutto',
      selected: 'selezionati'
    }
  },
  pt: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Simplificando a burocracia para todos',
      login: 'Entrar',
      register: 'Registrar',
      logout: 'Sair',
      dashboard: 'Painel',
      bills: 'Minhas contas',
      appointments: 'Consultas',
      history: 'Histórico de pagamentos',
      settings: 'Configurações',
      teoudat_zehout: 'Teoudat Zehout',
      code: 'Código pessoal',
      full_name: 'Nome completo',
      language: 'Idioma',
      welcome: 'Bem-vindo',
      total_debt: 'Total em aberto',
      unpaid_bills: 'Contas não pagas',
      upcoming_due: 'A vencer em breve',
      pay_now: 'Pagar agora',
      pay: 'Pagar',
      paid: 'Pago',
      unpaid: 'Não pago',
      overdue: 'Vencido',
      due_date: 'Data de vencimento',
      amount: 'Valor',
      category: 'Categoria',
      provider: 'Fornecedor',
      description: 'Descrição',
      status: 'Status',
      water: 'Água',
      electricity: 'Eletricidade',
      arnona: 'Imposto municipal',
      fines: 'Multas',
      education: 'Educação',
      health: 'Saúde',
      general: 'Geral',
      book_appointment: 'Agendar consulta',
      office_type: 'Tipo de escritório',
      office_name: 'Nome do escritório',
      select_date: 'Selecionar data',
      select_time: 'Selecionar hora',
      confirm_booking: 'Confirmar agendamento',
      post_office: 'Correios',
      misrad_hapanim: 'Ministério do Interior',
      bituah_leumi: 'Seguro Nacional',
      municipality: 'Prefeitura',
      payment_date: 'Data do pagamento',
      payment_method: 'Método de pagamento',
      view_details: 'Ver detalhes',
      all: 'Todos',
      recent_payments: 'Pagamentos recentes',
      my_appointments: 'Minhas consultas',
      no_bills: 'Nenhuma conta encontrada',
      no_appointments: 'Nenhuma consulta agendada',
      no_payments: 'Sem histórico de pagamentos',
      save_changes: 'Salvar alterações',
      cancel: 'Cancelar',
      payment_success: 'Pagamento bem-sucedido!',
      appointment_success: 'Consulta agendada com sucesso!',
      login_prompt: 'Por favor, faça login para acessar o sistema',
      register_prompt: 'Criar uma nova conta',
      already_have_account: 'Já tem uma conta?',
      dont_have_account: 'Não tem uma conta?',
      create_account: 'Criar conta',
      enter_details: 'Insira seus dados',
      filter_by_status: 'Filtrar por status',
      filter_by_category: 'Filtrar por categoria',
      notifications: 'Notificações',
      no_notifications: 'Sem notificações',
      bill_reminder: 'Lembrete de conta',
      mark_as_read: 'Marcar como lido',
      new_notification: 'Nova notificação',
      partial_payment: 'Pagamento parcial',
      full_payment: 'Pagamento total',
      payment_amount: 'Valor a pagar',
      remaining_balance: 'Saldo restante',
      generate_shovar: 'Gerar Shovar (PDF)',
      shovar_number: 'Número do Shovar',
      cash_payment: 'Pagamento em dinheiro',
      my_children: 'Meus filhos',
      add_child: 'Adicionar filho',
      child_name: 'Nome do filho',
      child_teoudat: 'Teoudat Zehout do filho',
      birth_date: 'Data de nascimento',
      school_name: 'Nome da escola',
      vaad_bayit: 'Comitê do prédio',
      chat_with_assistant: 'Conversar com assistente',
      ask_question: 'Faça uma pergunta...',
      how_can_help: 'Como posso ajudá-lo hoje?',
      change_address: 'Mudar endereço',
      my_address: 'Meu endereço',
      current_address: 'Endereço atual',
      new_address: 'Novo endereço',
      address_line_1: 'Endereço',
      city: 'Cidade',
      postal_code: 'CEP',
      update_address: 'Atualizar endereço',
      address_updated: 'Endereço atualizado com sucesso!',
      address_history: 'Histórico de endereços',
      organizations_updated: 'Órgãos atualizados',
      changed_on: 'Alterado em',
      propagated_to: 'Propagado automaticamente para todos os órgãos',
      install_app: 'Instalar o app SHALEM',
      install_app_subtitle: 'Acesso rápido pela tela inicial',
      install_now: 'Instalar agora',
      secure_payment: 'Pagamento seguro',
      amount_to_pay: 'Valor a pagar',
      card_number: 'Número do cartão',
      cardholder_name: 'Nome do titular',
      expiry_date: 'Data de validade',
      loading: 'Carregando...',
      saving: 'Salvando...',
      days_left: 'dias restantes',
      day_left: 'dia restante',
      no_urgent_bills: 'Nenhuma conta urgente!',
      all_caught_up: 'Tudo em dia!',
      no_unpaid_bills: 'Você não tem contas pendentes no momento.',
      profile_info: 'Informações do perfil',
      manage_preferences: 'Gerencie suas preferências',
      no_children_yet: 'Nenhum filho adicionado ainda',
      login_success: 'Login realizado!',
      register_success: 'Conta criada com sucesso!',
      select_all: 'Selecionar tudo',
      deselect_all: 'Desmarcar tudo',
      selected: 'selecionados'
    }
  },
  zh: {
    translation: {
      app_name: 'SHALEM',
      tagline: '为所有人简化官僚主义',
      login: '登录',
      register: '注册',
      logout: '登出',
      dashboard: '仪表板',
      bills: '我的账单',
      appointments: '预约',
      history: '付款历史',
      settings: '设置',
      teoudat_zehout: '身份证号',
      code: '个人密码',
      full_name: '全名',
      language: '语言',
      welcome: '欢迎',
      total_debt: '总未付',
      unpaid_bills: '未付账单',
      upcoming_due: '即将到期',
      pay_now: '立即支付',
      pay: '支付',
      paid: '已付',
      unpaid: '未付',
      overdue: '逾期',
      due_date: '到期日',
      amount: '金额',
      category: '类别',
      provider: '提供商',
      description: '描述',
      status: '状态',
      water: '水',
      electricity: '电',
      arnona: '财产税',
      fines: '罚款',
      education: '教育',
      health: '健康',
      general: '一般',
      book_appointment: '预约',
      office_type: '办公室类型',
      office_name: '办公室名称',
      select_date: '选择日期',
      select_time: '选择时间',
      confirm_booking: '确认预约',
      post_office: '邮局',
      misrad_hapanim: '内政部',
      bituah_leumi: '国家保险',
      municipality: '市政府',
      payment_date: '付款日期',
      payment_method: '付款方式',
      view_details: '查看详情',
      all: '全部',
      recent_payments: '最近付款',
      my_appointments: '我的预约',
      no_bills: '未找到账单',
      no_appointments: '没有预约安排',
      no_payments: '没有付款历史',
      save_changes: '保存更改',
      cancel: '取消',
      payment_success: '付款成功!',
      appointment_success: '预约成功!',
      login_prompt: '请登录以访问系统',
      register_prompt: '创建新账户',
      already_have_account: '已有账户?',
      dont_have_account: '没有账户?',
      create_account: '创建账户',
      enter_details: '输入您的详细信息',
      filter_by_status: '按状态过滤',
      filter_by_category: '按类别过滤',
      notifications: '通知',
      no_notifications: '没有通知',
      bill_reminder: '账单提醒',
      mark_as_read: '标记为已读',
      new_notification: '新通知',
      partial_payment: '部分付款',
      full_payment: '全额付款',
      payment_amount: '付款金额',
      remaining_balance: '剩余余额',
      generate_shovar: '生成付款单 (PDF)',
      shovar_number: '付款单号',
      cash_payment: '现金支付',
      my_children: '我的子女',
      add_child: '添加子女',
      child_name: '子女姓名',
      child_teoudat: '子女身份证号',
      birth_date: '出生日期',
      school_name: '学校名称',
      vaad_bayit: '楼委会',
      chat_with_assistant: '与助手聊天',
      ask_question: '提问...',
      how_can_help: '今天我能帮您什么？',
      change_address: '更改地址',
      my_address: '我的地址',
      current_address: '当前地址',
      new_address: '新地址',
      address_line_1: '街道地址',
      city: '城市',
      postal_code: '邮编',
      update_address: '更新地址',
      address_updated: '地址更新成功！',
      address_history: '地址历史',
      organizations_updated: '已更新的机构',
      changed_on: '更改日期',
      propagated_to: '已自动同步至所有机构',
      install_app: '安装 SHALEM 应用',
      install_app_subtitle: '从主屏幕快速访问',
      install_now: '立即安装',
      secure_payment: '安全支付',
      amount_to_pay: '付款金额',
      card_number: '卡号',
      cardholder_name: '持卡人姓名',
      expiry_date: '有效期',
      loading: '加载中...',
      saving: '保存中...',
      days_left: '天剩余',
      day_left: '天剩余',
      no_urgent_bills: '没有紧急账单！',
      all_caught_up: '全部已更新！',
      no_unpaid_bills: '您目前没有未付账单。',
      profile_info: '个人资料信息',
      manage_preferences: '管理您的偏好设置',
      no_children_yet: '尚未添加子女',
      login_success: '登录成功！',
      register_success: '账户创建成功！',
      select_all: '全选',
      deselect_all: '取消全选',
      selected: '已选'
    }
  },
  uk: {
    translation: {
      app_name: 'SHALEM',
      tagline: 'Спрощуємо бюрократію для всіх',
      login: 'Увійти',
      register: 'Реєстрація',
      logout: 'Вийти',
      dashboard: 'Панель',
      bills: 'Мої рахунки',
      appointments: 'Записи',
      history: 'Історія платежів',
      settings: 'Налаштування',
      teoudat_zehout: 'Теудат Зеут',
      code: 'Особистий код',
      full_name: 'Повне ім\'я',
      language: 'Мова',
      welcome: 'Ласкаво просимо',
      total_debt: 'Загальна заборгованість',
      unpaid_bills: 'Несплачені рахунки',
      upcoming_due: 'Термінові до оплати',
      pay_now: 'Оплатити зараз',
      pay: 'Оплатити',
      paid: 'Оплачено',
      unpaid: 'Не оплачено',
      overdue: 'Прострочено',
      due_date: 'Термін оплати',
      amount: 'Сума',
      category: 'Категорія',
      provider: 'Постачальник',
      description: 'Опис',
      status: 'Статус',
      water: 'Вода',
      electricity: 'Електрика',
      arnona: 'Арнона',
      fines: 'Штрафи',
      education: 'Освіта',
      health: 'Здоров\'я',
      general: 'Загальне',
      book_appointment: 'Записатися',
      office_type: 'Тип офісу',
      office_name: 'Назва офісу',
      select_date: 'Виберіть дату',
      select_time: 'Виберіть час',
      confirm_booking: 'Підтвердити запис',
      post_office: 'Пошта',
      misrad_hapanim: 'МВС',
      bituah_leumi: 'Бітуах Леумі',
      municipality: 'Муніципалітет',
      payment_date: 'Дата платежу',
      payment_method: 'Спосіб оплати',
      view_details: 'Деталі',
      all: 'Усі',
      recent_payments: 'Останні платежі',
      my_appointments: 'Мої записи',
      no_bills: 'Рахунки не знайдено',
      no_appointments: 'Немає запланованих записів',
      no_payments: 'Немає історії платежів',
      save_changes: 'Зберегти зміни',
      cancel: 'Скасувати',
      payment_success: 'Платіж успішний!',
      appointment_success: 'Запис успішно створено!',
      login_prompt: 'Будь ласка, увійдіть для доступу до системи',
      register_prompt: 'Створити новий обліковий запис',
      already_have_account: 'Вже є обліковий запис?',
      dont_have_account: 'Немає облікового запису?',
      create_account: 'Створити обліковий запис',
      enter_details: 'Введіть свої дані',
      filter_by_status: 'Фільтр за статусом',
      filter_by_category: 'Фільтр за категорією',
      notifications: 'Сповіщення',
      no_notifications: 'Немає сповіщень',
      bill_reminder: 'Нагадування про рахунок',
      mark_as_read: 'Позначити як прочитане',
      new_notification: 'Нове сповіщення',
      partial_payment: 'Часткова оплата',
      full_payment: 'Повна оплата',
      payment_amount: 'Сума платежу',
      remaining_balance: 'Залишок',
      generate_shovar: 'Створити шовар (PDF)',
      shovar_number: 'Номер шовара',
      cash_payment: 'Готівковий платіж',
      my_children: 'Мої діти',
      add_child: 'Додати дитину',
      child_name: 'Ім\'я дитини',
      child_teoudat: 'Теудат Зеут дитини',
      birth_date: 'Дата народження',
      school_name: 'Назва школи',
      vaad_bayit: 'Домовий комітет',
      chat_with_assistant: 'Чат з асистентом',
      ask_question: 'Задайте питання...',
      how_can_help: 'Чим я можу допомогти вам сьогодні?',
      change_address: 'Змінити адресу',
      my_address: 'Моя адреса',
      current_address: 'Поточна адреса',
      new_address: 'Нова адреса',
      address_line_1: 'Адреса',
      city: 'Місто',
      postal_code: 'Поштовий індекс',
      update_address: 'Оновити адресу',
      address_updated: 'Адресу успішно оновлено!',
      address_history: 'Історія адрес',
      organizations_updated: 'Організації оновлені',
      changed_on: 'Змінено',
      propagated_to: 'Автоматично передано в усі організації',
      install_app: 'Встановити додаток SHALEM',
      install_app_subtitle: 'Швидкий доступ з головного екрану',
      install_now: 'Встановити зараз',
      secure_payment: 'Безпечна оплата',
      amount_to_pay: 'Сума до оплати',
      card_number: 'Номер картки',
      cardholder_name: 'Ім\'я власника картки',
      expiry_date: 'Термін дії',
      loading: 'Завантаження...',
      saving: 'Збереження...',
      days_left: 'днів залишилось',
      day_left: 'день залишився',
      no_urgent_bills: 'Немає термінових рахунків!',
      all_caught_up: 'Все актуально!',
      no_unpaid_bills: 'У вас немає несплачених рахунків.',
      profile_info: 'Інформація профілю',
      manage_preferences: 'Керуйте своїми налаштуваннями',
      no_children_yet: 'Дітей ще не додано',
      login_success: 'Вхід виконано!',
      register_success: 'Обліковий запис створено!',
      select_all: 'Вибрати все',
      deselect_all: 'Скасувати все',
      selected: 'вибрано'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;